import { BrowserModule, provideClientHydration } from '@angular/platform-browser';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA, APP_INITIALIZER  } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { provideHttpClient, withFetch, withInterceptorsFromDi } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AppRoutingModule } from './app-routing.module';
import { UtilityModule } from './utility/utility.module';
import { WidgetsModule } from './widgets/widgets.module';

import { CommonService } from './Shared/Common/common.service';
import { AreaService } from './arealist.service';

import { AppComponent } from './app.component';
import { AppMasterComponent } from './Applications/app-master/app-master.component';
import { MyResourcesComponent } from './my-resources/my-resources.component';
import { PlatformsLandingPageComponent } from './Applications/platforms/platforms-landing-page.component';

function initializeApp(areaService: AreaService) {
  return () => areaService.initializeApp();
}

@NgModule({
  declarations: [
    AppComponent,
    AppMasterComponent,
    MyResourcesComponent,
    PlatformsLandingPageComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserModule,
    RouterModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    UtilityModule,
    WidgetsModule
  ],
  providers: [CommonService,
    AreaService,
    {
      provide: APP_INITIALIZER,
      useFactory: initializeApp,
      deps: [AreaService],
      multi: true
    },
    provideClientHydration(),
    // Fetch-based HttpClient instead of the XHR backend: on the server, the XHR
    // backend relies on the `xhr2` Node polyfill, whose completed requests don't
    // reliably notify Zone.js - Angular's SSR stability wait (which
    // CommonEngine.render() blocks on) can hang forever even though the request
    // already finished. Native fetch (available in Node 18+) integrates correctly.
    provideHttpClient(withFetch(), withInterceptorsFromDi())
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule { }
